import { authControllerLogin } from '~/lib/api';
import { useAuthStore } from '~/store';

const REQUEST_TIMEOUT_MS = 5000;
const INITIAL_DELAY_MS = 2000;

const sleep = (milliseconds: number) => new Promise((resolve) => setTimeout(resolve, milliseconds));

export const handleLogin = async (initData: string, referral: string | null) => {
  let attempt = 0;

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  while (true) {
    const abortController = new AbortController();
    const timeoutId = setTimeout(() => {
      abortController.abort();
    }, REQUEST_TIMEOUT_MS);

    try {
      const response = await authControllerLogin({ initData, referral }, abortController.signal);

      clearTimeout(timeoutId);

      useAuthStore.getState().setUser({
        firstName: response.data.user.firstName,
        lastName: response.data.user.lastName ?? '',
        onboarded: response.data.user.onboarded,
        isPremium: response.data.user.isPremium,
        referralUserId: response.data.user.referralUserId || null,
        onboardingDaysOnTelegram: response.data.user.onboardingDaysOnTelegram,
        xp: response.data.user.xp,
      });

      useAuthStore.getState().setAccessToken(response.data.access_token, response.data.expires_at);

      return response.data;
    } catch {
      clearTimeout(timeoutId);

      const delayMs = Math.min(INITIAL_DELAY_MS * Math.pow(2, attempt));
      await sleep(delayMs);
      attempt++;
    }
  }
};
